export class AspectInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get hasExportTrait() {
        return this.aspect.exports.length > 0;
    }
}
